import React, { useEffect, useMemo, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { imgUrl, siteUrl } from '../../config/config';
import { getFreight } from '../../store/ducks/freight/actions';
import freightSelector from '../../store/ducks/freight/selectors/freightSelector';
import './Freight.scss';
import { PageMeta } from 'components/PageMeta/PageMeta';

import { LangContext } from "../../components/App/App";

const Freight = () => {

    const [currentMode, currentModeChange] = useState(null);
    const freight = useSelector(freightSelector);
    const status = useSelector(status => status.freightReducer.status);
    const dispatch = useDispatch();

    const hideMode = () => {
        currentModeChange(null);
    };

    const showMode = (mode: string) => {
        if (currentMode === mode) {
            currentModeChange(null);
        } else {
            currentModeChange(mode);
        }
    };

    const lang = useContext(LangContext);
    useEffect(() => {
        if (lang && lang.lang && lang.lang.value && status === "IDLE") {
            dispatch(getFreight({lang: lang.lang.value}));
        }
    }, [lang]);

    const [isMobile, setMobile] = useState(false);
    useEffect(() => {
        function resize() {
            if (window.innerWidth < 850) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    })

    return (
        <>
            <PageMeta
                title="World-class freight"
                description="At FertiStream, we understand that world-class freight logistics are crucial to your succes"
            />
            {freight && status && status === "SUCCESS" &&
                <>
                    <section className="freight">
                        <div className="container">
                            <h1
                                className="page-title"
                                dangerouslySetInnerHTML={{__html: freight.title}}
                            />
                            <div
                                className="page-descr"
                                dangerouslySetInnerHTML={{__html: freight.description}}
                            />
                            {/*<div className="freight-img"></div>*/}
                        </div>
                    </section>

                    {freight && freight.content && freight.content.length > 0 && freight.content.map(item => (
                        <section className="advantage">
                            <div className="container">
                                <div className="advantage-wrapper">
                                    <div className="advantage-img">
                                        <img
                                            src={siteUrl + item.image}
                                            alt=""
                                        />
                                    </div>
                                    <h2
                                        className="section-title"
                                        dangerouslySetInnerHTML={{__html: item.title}}
                                    />
                                    {item.text && item.text.length > 0 &&
                                        <div className="advantage-list">
                                            {item.text.map(text => (
                                                <div className="advantage-list__item">
                                                    {text.title &&
                                                        <div
                                                            className="advantage-list__item-title"
                                                            dangerouslySetInnerHTML={{__html: text.title}}
                                                        />
                                                    }
                                                    <div
                                                        className="advantage-list__item-descr"
                                                        dangerouslySetInnerHTML={{__html: text.description}}
                                                    />
                                                    {text.carriers && text.carriers.length > 0 &&
                                                        <div className="modes-list__item-btns">
                                                            {text.carriers.map((carrier, index) => (
                                                                <>
                                                                    <div
                                                                        className={`modes-list__item-btn ${
                                                                            currentMode === "carrier-" + carrier.id + text.id
                                                                                ? "active"
                                                                                : ""
                                                                        }`}
                                                                        data-modes={"carrier-" + carrier.id + text.id}
                                                                        onClick={() =>
                                                                            showMode("carrier-" + carrier.id + text.id)
                                                                        }
                                                                        onMouseEnter={() => {
                                                                            if (isMobile) return;
                                                                            showMode("carrier-" + carrier.id + text.id)
                                                                        }}
                                                                        onMouseLeave={() => {
                                                                            if (isMobile) return;
                                                                            showMode(null)
                                                                        }}
                                                                    >
                                                                        {carrier.title && carrier.title}
                                                                    </div>
                                                                    <div
                                                                        className={`modes-item__btn-info ${
                                                                            currentMode === "carrier-" + carrier.id + text.id
                                                                                ? "show"
                                                                                : ""
                                                                        }`}
                                                                        data-modes={"carrier-" + carrier.id + text.id}
                                                                    >
                                                                        <div className="modes-item__header">
                                                                            <strong>{carrier.title && carrier.title}</strong>
                                                                            <span className="modes-item__btn-close">
                                                                                <img
                                                                                    src="/assets/img/close.svg"
                                                                                    alt=""
                                                                                    onClick={hideMode}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                        {carrier.stats && carrier.stats.length > 0 &&
                                                                            <div className="btn-table">
                                                                                {carrier.stats.map(stat => (
                                                                                    <div className="btn-table__item" key={stat.id}>
                                                                                        <strong>{stat.title}</strong>
                                                                                        <span>{stat.value}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </>
                                                            ))}
                                                        </div>
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>
                        </section>
                    ))}

                    {freight.contacts && freight.contacts.link && (
                        <section className="bottom-sec bottom-sec-two">
                            <div className="container">
                                <div className="bottom-sec__wrapper">
                                    <h2
                                        className="section-title"
                                        dangerouslySetInnerHTML={{  __html: freight.contacts.title }}
                                    />
                                    <div
                                        className="section-description"
                                        dangerouslySetInnerHTML={{ __html: freight.contacts.description }}
                                    />
                                    {freight.contacts.link &&
                                    freight.contacts.link.title &&
                                    freight.contacts.link.url && (
                                        <Link
                                            to={freight.contacts.link.url}
                                            className="contact-us"
                                            dangerouslySetInnerHTML={{__html: freight.contacts.link.title }}
                                        />
                                    )}
                                </div>
                            </div>
                        </section>
                    )}
                </>
            }
        </>
    );
};

export default Freight;
